<template>
	<div class="loading-splash">
		<div class="lds-ripple"><div></div><div></div></div>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loading-splash {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0,0,0, 0.4);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 99;

	h1 {
		margin: 40px 0 0;
	}
}
</style>
